module.exports = {"510525100":"古蔺镇","510525101":"龙山镇","510525102":"永乐镇","510525103":"太平镇","510525104":"二郎镇","510525105":"大村镇","510525106":"石宝镇","510525107":"丹桂镇","510525108":"茅溪镇","510525109":"观文镇","510525110":"双沙镇","510525111":"德耀镇","510525112":"护家镇","510525113":"石屏镇","510525114":"土城镇","510525115":"皇华镇","510525116":"鱼化镇","510525117":"东新镇","510525118":"椒园镇","510525119":"马蹄镇","510525120":"桂花镇","510525121":"黄荆镇","510525207":"白泥乡","510525209":"马嘶苗族乡","510525212":"箭竹苗族乡","510525214":"大寨苗族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510525.json
// module id = 2292
// module chunks = 0